import { render, staticRenderFns } from "./rejectionReport.vue?vue&type=template&id=2dc818ca&scoped=true&"
import script from "./rejectionReport.vue?vue&type=script&lang=js&"
export * from "./rejectionReport.vue?vue&type=script&lang=js&"
import style0 from "./rejectionReport.vue?vue&type=style&index=0&id=2dc818ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc818ca",
  null
  
)

export default component.exports